import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ShowroomLocatorContent from 'components/consumer/consumer-new-footer/components/ShowroomLocatorContent';
const NavbarShowroomLocator = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-[320px] lg:w-[350px] min-[1440px]:w-[400px] px-4 py-3 font-bold"><div className="text-sm text-gray mb-2 font-bold text-lg">Find your closest showroom</div><ShowroomLocatorContent inputId="navbar-showroom-zipcode" autoFocusInput={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default NavbarShowroomLocator;